/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback } from 'react';
import { MyFileGridViewProps } from '../../types/file-manager.type';
import { createBasicFileFilter } from '../common-filters';
// import { BaseGridView } from '../basic-grid-view';
import { useFileManagerConfig } from '../../hooks/use-file-manager-config';
import { MyFileBaseGridView } from '../file-manager-basic-grid-view';

const MyFileGridView: React.FC<MyFileGridViewProps> = (props) => {
  const config = useFileManagerConfig();
  const queryBuilder = useCallback(
    (params: any) => ({
      page: params.page,
      pageSize: params.pageSize,
      filter: params.filters,
    }),
    []
  );

  const filterFiles = useCallback(createBasicFileFilter(), []);
  return <MyFileBaseGridView {...props} queryBuilder={queryBuilder} filterFiles={filterFiles} queryHook={config.queryHook} extraParams={{ 'sharedOnly': false, sort: [{ id: 'lastModified', desc: true }] }} />
  // old card
  // return <BaseGridView {...props} queryBuilder={queryBuilder} filterFiles={filterFiles} queryHook={config.queryHook} />;
};

export default MyFileGridView;
